import React from "react";

import dayjs from "dayjs";
import { DoneCheck, Close } from "icons";

import { Typography, Tag } from "clearsense-ui/components";
import { ColumnStyle, LinkText, Steward } from "components/Common/TableStyle";

const getStatusColor = text => {
  switch (text) {
    case "Ingested":
      return "#EBF4EC";
    case "Profiled":
      return "#FDF0E3";
    case "Scanned":
      return "#FAEAEA";
    default:
      return "";
  }
};

const getStatusIcon = text => (text === "Failed" ? Close : DoneCheck);

export const STEWARDS_COLUMNS = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Email Address",
    dataIndex: "email_address",
    key: "email_address",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
];

export const CDE_COLUMNS = () => [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    fixed: "left",
    width: 150,
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: 300,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 200,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    render: row => <Steward name={row?.name} title={row?.role} />,
    width: 200,
  },
  {
    dataIndex: "is_secured",
    key: "is_secured",
    title: "Secured CDE",
    render: row => {
      if (row === "") return "No";
      else if (row === "phi") return "PHI";

      return "Business Sensitive";
    },
    width: 150,
  },
  {
    dataIndex: "mapping_status",
    key: "mapping_status",
    title: "Mapping Status",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "data_source",
    key: "data_source",
    title: "# Data Source",
    width: 150,
    render: text => (text ? text : 0),
  },
];

export const DATA_SOURCE_COLUMNS = () => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: 150,
    render: text => <LinkText text={text} state={{ parent: text }} />,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 400,
    render: text => <Typography style="large">{text}</Typography>,
  },
  {
    title: "Type",
    key: "db_name",
    dataIndex: "db_name",
    width: 200,
    render: () => <ColumnStyle text="RDBMS" />,
  },
  {
    title: "Data Source Status",
    key: "status",
    dataIndex: "status",
    width: 200,
    render: text =>
      text ? (
        <Tag
          label={text}
          color={getStatusColor(text)}
          icon={getStatusIcon(text)}
          className="flex-row-reverse "
        />
      ) : (
        <Tag
          label="Ingested"
          color={getStatusColor("Ingested")}
          icon={getStatusIcon("Ingested")}
          className="flex-row-reverse "
        />
      ),
  },
  {
    title: "# Data Source Data Elements",
    key: "dsdes_count",
    dataIndex: "dsdes_count",
    width: 150,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "# Incomplete DSDE",
    key: "incomplete_mappings",
    dataIndex: "incomplete_mappings",
    width: 150,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    width: 200,
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    width: 200,
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Last Updated",
    key: "updated_at",
    dataIndex: "updated_at",
    width: 200,
    render: text => dayjs(text).format("MM/DD/YYYY"),
  },
];

export const STEWARDS_DATA = [
  {
    key: 1,
    name: "Debbie Data Steward",
    role: "Steward",
    phone: "(555) 555-1234",
    email_address: "debbie@fakemail.com",
  },
  {
    key: 2,
    name: "Don Data Steward",
    role: "Steward",
    phone: "(555) 555-2345",
    email_address: "don@fakemail.com",
  },
  {
    key: 3,
    name: "Doug Data Steward",
    role: "Steward",
    phone: "(555) 555-3456",
    email_address: "doug@fakemail.com",
  },
  {
    key: 4,
    name: "Andy App Steward",
    role: "Application Steward",
    phone: "(555) 555-4567",
    email_address: "andy@fakemail.com",
  },
  {
    key: 5,
    name: "Amy App Steward",
    role: "Application Steward",
    phone: "(555) 555-5678",
    email_address: "amy@fakemail.com",
  },
];
